module.exports = __webpack_public_path__ + "img/zs10.bd064c4f.jpg";